module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n    main\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fd7a80e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 386
// module chunks = 18